module.exports = __webpack_public_path__ + "img/Arcade_Machine.cb94209e.png";